import { render } from "./Inspections.vue?vue&type=template&id=5eb8fdb4&scoped=true"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"

import "./Inspections.vue?vue&type=style&index=0&id=5eb8fdb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb8fdb4"]])

export default __exports__